export const REMINDER_COOLDOWN_MS = 45_000;

export type ReminderCooldowns = Record<string, number>;

export const getReminderCooldownStorageKey = (
  workspaceId: string,
  cycleId: string,
) => `checkin-reminder-cooldowns:${workspaceId}:${cycleId}`;

export const readReminderCooldowns = (
  storageKey: string,
  now = Date.now(),
): ReminderCooldowns => {
  try {
    const stored = window.localStorage.getItem(storageKey);
    if (!stored) return {};
    const parsed = JSON.parse(stored) as ReminderCooldowns;
    return Object.fromEntries(
      Object.entries(parsed).filter(
        ([submissionId, expiresAt]) =>
          Boolean(submissionId) &&
          typeof expiresAt === 'number' &&
          expiresAt > now,
      ),
    );
  } catch {
    return {};
  }
};

export const writeReminderCooldowns = (
  storageKey: string,
  cooldowns: ReminderCooldowns,
) => {
  try {
    if (Object.keys(cooldowns).length) {
      window.localStorage.setItem(storageKey, JSON.stringify(cooldowns));
    } else {
      window.localStorage.removeItem(storageKey);
    }
  } catch {
    // The cooldown remains active in component state if storage is unavailable.
  }
};

export const getReminderSecondsRemaining = (
  expiresAt: number | undefined,
  now = Date.now(),
) => (expiresAt ? Math.max(0, Math.ceil((expiresAt - now) / 1000)) : 0);
